import OrangeLocatorSales from '../components/dashboard/orange-locator/OrangeLocatorSales'

const OrangeLocatorSalesPage = () => <OrangeLocatorSales />

export default OrangeLocatorSalesPage
